import { z } from 'zod';
import { roleSchema } from '../roles.js';
import { userDetailSchema } from './users.js';
/**
 * Self-registration (owner, 2026-09-14, story 33). Anyone with the link fills
 * a short form — no company code, no CAPTCHA, by the owner's decision — and
 * the submission waits as a `registrations` document. Nothing reaches
 * Firebase Auth until an admin approves it, placing the person on a platoon
 * or team with roles; rejecting it leaves a record. An admin can switch the
 * whole thing off on the settings page (`PATCH /settings`).
 */
export const registrationStatusSchema = z.enum(['pending', 'approved', 'rejected']);
/** POST /api/public/registration — the public form. */
export const registrationRequestSchema = z.object({
    firstName: z.string().trim().min(1).max(80),
    lastName: z.string().trim().min(1).max(80),
    email: z.string().trim().toLowerCase().email().max(254),
    phone: z.string().trim().min(5).max(40),
    personalNumber: z.string().trim().regex(/^[0-9]{5,10}$/),
});
export const registrationSchema = z.object({
    id: z.string().min(1),
    firstName: z.string(),
    lastName: z.string(),
    email: z.string(),
    phone: z.string(),
    personalNumber: z.string(),
    status: registrationStatusSchema,
    submittedAt: z.string().nullable(),
    decidedAt: z.string().nullable(),
    decidedBy: z.string().nullable(),
    decisionNote: z.string().nullable(),
    /** The account an approval created. */
    createdUid: z.string().nullable(),
});
/** GET /api/public/registration — is the form open? The page and the sign-in link both ask. */
export const registrationStatusResponseSchema = z.object({ enabled: z.boolean() });
export const registrationResponseSchema = z.object({ registration: registrationSchema });
/** GET /api/registrations?status= — admin. */
export const registrationsQuerySchema = z.object({
    status: registrationStatusSchema.default('pending'),
});
export const registrationsResponseSchema = z.object({ registrations: z.array(registrationSchema) });
/** POST /api/registrations/:id/approve — admin: place them and create the account. */
export const approveRegistrationRequestSchema = z.object({
    /** A team, or a platoon for a soldier with no team. */
    unitId: z.string().min(1),
    roles: z.array(roleSchema).min(1).max(6).default(['soldier']),
    rank: z.string().trim().max(40).nullable().default(null),
    title: z.string().trim().max(80).nullable().default(null),
});
export const approveRegistrationResponseSchema = z.object({
    registration: registrationSchema,
    user: userDetailSchema,
});
/** POST /api/registrations/:id/reject — admin. */
export const rejectRegistrationRequestSchema = z.object({
    note: z.string().trim().max(500).nullable().default(null),
});
/** Per address, per hour — enough for a family sharing a connection, not for a script. */
export const MAX_REGISTRATIONS_PER_IP_HOUR = 10;
//# sourceMappingURL=registration.js.map